import '../../assets/index37.css';var Y = Object.defineProperty, J = Object.defineProperties;
var Q = Object.getOwnPropertyDescriptors;
var _ = Object.getOwnPropertySymbols;
var W = Object.prototype.hasOwnProperty, I = Object.prototype.propertyIsEnumerable;
var C = (o, e, t) => e in o ? Y(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t, S = (o, e) => {
  for (var t in e || (e = {}))
    W.call(e, t) && C(o, t, e[t]);
  if (_)
    for (var t of _(e))
      I.call(e, t) && C(o, t, e[t]);
  return o;
}, T = (o, e) => J(o, Q(e));
var L = (o, e) => {
  var t = {};
  for (var r in o)
    W.call(o, r) && e.indexOf(r) < 0 && (t[r] = o[r]);
  if (o != null && _)
    for (var r of _(o))
      e.indexOf(r) < 0 && I.call(o, r) && (t[r] = o[r]);
  return t;
};
import { jsx as z } from "react/jsx-runtime";
import * as h from "react";
import y, { useLayoutEffect as U } from "react";
import { ErrorMessage as X } from "../../molecules/ErrorMessage/index.js";
import { Label as Z } from "../Label/index.js";
import { _ as q, a as D } from "../../objectWithoutPropertiesLoose-DiWPeE4c.js";
import { g as K } from "../../get-env-CiXMSQeN.js";
import { j as V, b as ee } from "../../factory-BnRIVbT0.js";
import { I as P } from "../../InputBase-D95P7hmN.js";
var te = U, re = function(e) {
  var t = y.useRef(e);
  return te(function() {
    t.current = e;
  }), t;
}, N = function(e, t) {
  if (typeof e == "function") {
    e(t);
    return;
  }
  e.current = t;
}, oe = function(e, t) {
  var r = y.useRef();
  return y.useCallback(function(n) {
    e.current = n, r.current && N(r.current, null), r.current = t, t && N(t, n);
  }, [t]);
}, k = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0",
  display: "block"
}, ne = function(e) {
  Object.keys(k).forEach(function(t) {
    e.style.setProperty(t, k[t], "important");
  });
}, A = ne, i = null, B = function(e, t) {
  var r = e.scrollHeight;
  return t.sizingStyle.boxSizing === "border-box" ? r + t.borderSize : r - t.paddingSize;
};
function ie(o, e, t, r) {
  t === void 0 && (t = 1), r === void 0 && (r = 1 / 0), i || (i = document.createElement("textarea"), i.setAttribute("tabindex", "-1"), i.setAttribute("aria-hidden", "true"), A(i)), i.parentNode === null && document.body.appendChild(i);
  var n = o.paddingSize, s = o.borderSize, a = o.sizingStyle, l = a.boxSizing;
  Object.keys(a).forEach(function(m) {
    var v = m;
    i.style[v] = a[v];
  }), A(i), i.value = e;
  var d = B(i, o);
  i.value = e, d = B(i, o), i.value = "x";
  var c = i.scrollHeight - n, u = c * t;
  l === "border-box" && (u = u + n + s), d = Math.max(u, d);
  var p = c * r;
  return l === "border-box" && (p = p + n + s), d = Math.min(p, d), [d, c];
}
var M = function() {
}, ae = function(e, t) {
  return e.reduce(function(r, n) {
    return r[n] = t[n], r;
  }, {});
}, de = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak",
  "wordSpacing",
  "scrollbarGutter"
], se = !!document.documentElement.currentStyle, ue = function(e) {
  var t = window.getComputedStyle(e);
  if (t === null)
    return null;
  var r = ae(de, t), n = r.boxSizing;
  if (n === "")
    return null;
  se && n === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var s = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), a = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: s,
    borderSize: a
  };
}, le = ue;
function j(o, e, t) {
  var r = re(t);
  h.useLayoutEffect(function() {
    var n = function(a) {
      return r.current(a);
    };
    if (o)
      return o.addEventListener(e, n), function() {
        return o.removeEventListener(e, n);
      };
  }, []);
}
var ce = function(e) {
  j(window, "resize", e);
}, pe = function(e) {
  j(document.fonts, "loadingdone", e);
}, fe = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], he = function(e, t) {
  var r = e.cacheMeasurements, n = e.maxRows, s = e.minRows, a = e.onChange, l = a === void 0 ? M : a, d = e.onHeightChange, c = d === void 0 ? M : d, u = q(e, fe), p = u.value !== void 0, m = h.useRef(null), v = oe(m, t), E = h.useRef(0), w = h.useRef(), x = function() {
    var g = m.current, R = r && w.current ? w.current : le(g);
    if (R) {
      w.current = R;
      var H = ie(R, g.value || g.placeholder || "x", s, n), b = H[0], G = H[1];
      E.current !== b && (E.current = b, g.style.setProperty("height", b + "px", "important"), c(b, {
        rowHeight: G
      }));
    }
  }, $ = function(g) {
    p || x(), l(g);
  };
  return h.useLayoutEffect(x), ce(x), pe(x), /* @__PURE__ */ h.createElement("textarea", D({}, u, {
    onChange: $,
    ref: v
  }));
}, ge = /* @__PURE__ */ h.forwardRef(he);
const me = {}, F = V((o, e) => {
  const u = ee(
    "Textarea",
    me,
    o
  ), { autosize: t, maxRows: r, minRows: n, __staticSelector: s, resize: a } = u, l = L(u, ["autosize", "maxRows", "minRows", "__staticSelector", "resize"]), d = t && K() !== "test", c = d ? { maxRows: r, minRows: n } : {};
  return /* @__PURE__ */ z(
    P,
    S(T(S({
      component: d ? ge : "textarea",
      ref: e
    }, l), {
      __staticSelector: s || "Textarea",
      multiline: !0,
      "data-no-overflow": t && r === void 0 || void 0,
      __vars: { "--input-resize": a }
    }), c)
  );
});
F.classes = P.classes;
F.displayName = "@mantine/core/Textarea";
const ve = "TextField-module__root___9xSbN", xe = "TextField-module__wrapper___fLJF-", be = "TextField-module__input___shQrf", _e = "TextField-module__section___PMsf6", Se = "TextField-module__label___yB4jx", ze = "TextField-module__error___sL5lp", ye = "TextField-module__description___uE3y4", f = {
  root: ve,
  wrapper: xe,
  input: be,
  section: _e,
  label: Se,
  error: ze,
  description: ye
}, Ie = y.forwardRef((c, d) => {
  var u = c, {
    error: o,
    rightSection: e,
    multiline: t,
    maxRows: r = 5,
    minRows: n = 1,
    label: s,
    withAsterisk: a
  } = u, l = L(u, [
    "error",
    "rightSection",
    "multiline",
    "maxRows",
    "minRows",
    "label",
    "withAsterisk"
  ]);
  const p = typeof s == "string" ? /* @__PURE__ */ z(Z, { label: s, withAsterisk: a }) : s;
  return /* @__PURE__ */ z(
    F,
    T(S({
      classNames: {
        root: f.root,
        input: f.input,
        wrapper: f.wrapper,
        label: f.label,
        section: f.section,
        error: f.error,
        description: f.description
      },
      inputWrapperOrder: ["label", "input", o ? "error" : "description"],
      autosize: !0,
      maxRows: r,
      minRows: n,
      error: o && /* @__PURE__ */ z(X, { error: o })
    }, l), {
      ref: d,
      component: t ? void 0 : "input",
      label: p
    })
  );
});
export {
  Ie as TextField
};
